import { CreditGroupDto } from './CreditGroupDto';
import { Credit as CreditType } from '../../api/graphql/generated/schema';

export class CreditDto {
  private _serviceId: string;
  private _creditGroups: Array<CreditGroupDto>;

  constructor(serviceId: string, creditGroups: Array<CreditGroupDto>) {
    this._serviceId = serviceId;
    this._creditGroups = creditGroups;
  }

  static convertFromCredit(credit: CreditType) {
    let _creditGroups: Array<CreditGroupDto> = [];
    credit?.creditGroups
      ?.map((cg) => cg && CreditGroupDto.convertFromCreditGroup(cg))
      .forEach((cgdto) => cgdto && _creditGroups.push(cgdto));
    return new CreditDto(credit.servicePackage.id, _creditGroups);
  }

  get serviceId(): string {
    return this._serviceId;
  }

  set serviceId(value: string) {
    this._serviceId = value;
  }

  get creditGroups(): Array<CreditGroupDto> {
    return this._creditGroups;
  }

  set creditGroups(value: Array<CreditGroupDto>) {
    this._creditGroups = value;
  }

  hasAllValidGroups() {
    return this._creditGroups && !this._creditGroups.some((item) => item.hasAnyInvalidItem());
  }
}
